var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ItineraryToolbar'),_vm._v(" "),_c('div',{staticClass:"iande-container mt-lg iande-stack stack-lg"}),_vm._v(" "),_c('ItineraryWelcomeModal',{ref:"modal"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }